import { render, staticRenderFns } from "./live-tab.vue?vue&type=template&id=4d510e58"
import script from "./live-tab.vue?vue&type=script&lang=js"
export * from "./live-tab.vue?vue&type=script&lang=js"
import style0 from "./live-tab.vue?vue&type=style&index=0&id=4d510e58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports